import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { translate } from 'react-i18next';

import AssetsFormSections from 'components/assets/form_sections';
import AssetsDepreciation from 'containers/assets/edit_sections/AssetsEditDepreciationSection';
import * as AssetDetail from 'fixedassets/components/detail';
import * as Common from 'common/components';
import { createRoute } from 'lib/util';

import PDFassetDetailUnitario from '../../../../../lib/pdfs/EmployeesAssetUnitarioPDF';
import PDFassetDetailUnitarioPrice from '../../../../../lib/pdfs/EmployeesAssetUnitarioPricePDF';
import { generateAssetDetailPDF } from '../../../../../lib/pdfs/AssetDetail';
import { detailVoucherOptions, exportIndividualVoucher, locationCatalog } from 'lib/vouchers';

import { Form as FormCustom } from 'common/components';
import AssetFormCodes from '../../../../../components/assets/form_sections/AssetFormCodes';
const { Form } = Common;

class AssetDetailView extends PureComponent {
  static propTypes = {
    isFetching: PropTypes.bool,
    asset: PropTypes.object,
    company: PropTypes.object,
    subcompany: PropTypes.object,
    groups: PropTypes.object,
    permissions: PropTypes.object,
    user: PropTypes.object,
    onCustodyVoucherSaved: PropTypes.func,
  };

  state = { showCustodyVoucher: false };

  handlePrintButtonClick = async () => {
    try {
      await generateAssetDetailPDF(this.props.asset, this.props.company, this.props.subcompany, this.props);
    } catch (error) {
      console.error(
        'Error generating PDF for asset',
        this.props.asset && this.props.asset.id,
        error
      );
      if (this.props.error) this.props.error('error.generate_pdf');
    }
  };

  // "Acciones > Exportar PDF" in the client's own format (lib/vouchers/clientConfig).
  handleExportVoucher = (format, withPrice) => async (e) => {
    e.preventDefault();
    const { asset, company, subcompany, t, user } = this.props;
    const ctx = { company, subcompany, t, user, locations: this.locations() };
    try {
      await exportIndividualVoucher(format, asset, ctx, { withPrice });
    } catch (error) {
      console.error('Error generating the custody voucher for asset', asset && asset.id, error);
      if (this.props.error) this.props.error('error.generate_pdf');
    }
  };

  // Locations and sublocations of the asset's path, for AutoSur's voucher.
  locations = () => locationCatalog(this.props.locations, this.props.sublocations);

  // "Acciones > Firmar vale de resguardo": the modal signs and saves the voucher
  // in the client's format, or downloads it for signing on paper.
  handleCustodyVoucherClick = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    this.setState({ showCustodyVoucher: true });
  };

  handleCustodyVoucherClose = () => this.setState({ showCustodyVoucher: false });

  render = () => {
    const { asset, permissions } = this.props;
    const vouchers = detailVoucherOptions(this.props.company, this.props.subcompany, asset);
    let indexInteger = '';
    if (asset.indexInteger && asset.indexInteger[0] && asset.indexInteger[0].indexString) {
      indexInteger = asset.indexInteger[0].indexString;
    }

    return (
      <Common.Wrapper fluid={true}>
        <Common.Header title={this.props.t('assets.title')} />

        <div className="col-12">
          <Common.Portlet
            title={this.props.t('assets.detail')}
            subtitle={
              (this.props.asset && `${asset.number} - ${asset.name} - ${indexInteger}`) || ''
            }
            button={
              permissions['acl.assets.update'] ? (
                <Form.Link
                  to={createRoute(
                    this.props.company.id,
                    this.props.subcompany.id,
                    'assets/' + this.props.asset.id + '/edit'
                  )}
                  className={classnames('btn btn-secondary pull-right ml-5')}
                >
                  {this.props.t('actions.edit')}
                  <div className="clearfix" />
                </Form.Link>
              ) : null
            }
            buttonTwo={
              // The "Actions" menu: the custody vouchers in the client's format.
              vouchers.items.length ? (
                <div className="dropdown ml-2">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {this.props.t('common.actions')}
                  </button>
                  <div className="dropdown-menu p-2 mr-5" aria-labelledby="dropdownMenuButton">
                    {vouchers.items.includes('generic') ? (
                      <PDFassetDetailUnitario
                        subcompany={this.props.subcompany}
                        asset={this.props.asset}
                      />
                    ) : null}
                    {vouchers.items.includes('genericPrice') ? (
                      <PDFassetDetailUnitarioPrice
                        subcompany={this.props.subcompany}
                        asset={this.props.asset}
                      />
                    ) : null}
                    {vouchers.items.includes('export') ? (
                      <a
                        className="btn btn-sm btn-outline-primary w-100 my-1"
                        href="#export"
                        onClick={this.handleExportVoucher(vouchers.format, false)}
                      >
                        {this.props.t('actions.exportPDF')}
                      </a>
                    ) : null}
                    {vouchers.items.includes('exportPrice') ? (
                      <a
                        className="btn btn-sm btn-outline-dark w-100 my-1"
                        href="#export"
                        onClick={this.handleExportVoucher(vouchers.format, true)}
                      >
                        {this.props.t('actions.exportPDFprice')}
                      </a>
                    ) : null}
                    {vouchers.items.includes('sign') ? (
                      <a
                        className="btn btn-sm btn-outline-success w-100 my-1"
                        href="#sign"
                        onClick={this.handleCustodyVoucherClick}
                      >
                        {this.props.t('custodyVoucher.signFromActions')}
                      </a>
                    ) : null}
                  </div>
                </div>
              ) : null
            }
            icon={'qrcode'}
          >
            <button
              className="btn btn-secondary pull-right ml-5"
              onClick={this.handlePrintButtonClick}
            >
              <i className="fa fa-print mr-1" /> Detalle del activo
            </button>
            {vouchers.items.includes('sign') ? (
              <AssetDetail.CustodyVoucherModal
                format={vouchers.format}
                show={this.state.showCustodyVoucher}
                handleClose={this.handleCustodyVoucherClose}
                onSaved={this.props.onCustodyVoucherSaved || (() => {})}
                asset={asset}
                company={this.props.company}
                subcompany={this.props.subcompany}
                user={this.props.user}
                locations={this.locations()}
                error={this.props.error}
                success={this.props.success}
              />
            ) : null}

            <AssetDetail.General asset={this.props.asset} />
            <AssetDetail.Location
              asset={this.props.asset}
              locations={this.props.locations}
              sublocations={this.props.sublocations}
            />
            <AssetDetail.Buy asset={this.props.asset} />
            <AssetDetail.Accountant asset={this.props.asset} />
            <AssetDetail.Project asset={this.props.asset} />
            <AssetDetail.Assurance asset={this.props.asset} />
            <AssetDetail.Bill asset={this.props.asset} />
            <AssetsFormSections.Codes values={this.props.asset} />
            <AssetDetail.Codes asset={this.props.asset} />
            <AssetDetail.Notes asset={this.props.asset} />
            <AssetDetail.Files asset={this.props.asset} />
            <AssetDetail.InsAndOuts
              asset={this.props.asset}
              company={this.props.company}
              subcompany={this.props.subcompany}
              permissions={this.props.permissions}
              OutputAsset={this.props.OutputAsset}
              InputAsset={this.props.InputAsset}
              AceptOutput={this.props.AceptOutput}
              RejectOutput={this.props.RejectOutput}
            />
            <FormCustom.CustomFields
              errors={{}}
              handleCustomFieldChange={() => {}}
              handleGroupChange={() => {}}
              isSubmitted={false}
              t={this.props.t}
              values={this.props.asset}
              groups={this.props.groups}
              readOnly={true}
            ></FormCustom.CustomFields>
            {this.props.company &&
            this.props.subcompany &&
            this.props.asset._status &&
            this.props.asset._status.key === 'DEPRECIATING' ? (
              <AssetsDepreciation
                asset={this.props.asset}
                company={this.props.company}
                subcompany={this.props.subcompany}
                inpcs={this.props.inpcs}
              />
            ) : (
              <div className="col-md-12 mt-3">
                <Form.Link
                  to={createRoute(this.props.company.id, this.props.subcompany.id, 'assets')}
                  className={classnames('btn btn-secondary pull-right mr-3')}
                >
                  {this.props.t('actions.cancel')}
                </Form.Link>
                <div className="clearfix" />
              </div>
            )}
          </Common.Portlet>
        </div>
      </Common.Wrapper>
    );
  };
}

export default translate()(AssetDetailView);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/AssetDetailView.js